import { http } from '@/api/http';

export interface HomePopupItem {
  id: number | string;
  title: string;
  linkUrl: string;
  imageUrl: string;
  imageFit: 'contain' | 'cover';
  imageObjectPosition: string;
  imageScale: number;
}

interface PopupApiResponse {
  id: number;
  title: string;
  linkUrl: string;
  imageUrl: string;
  imageFit: 'contain' | 'cover';
  imageObjectPosition: string;
  imageScale: number;
}

export const homePopupQueryKey = ['home', 'popups'] as const;

const mapPopup = (popup: PopupApiResponse): HomePopupItem => ({
  id: popup.id,
  title: popup.title,
  linkUrl: popup.linkUrl,
  imageFit: popup.imageFit,
  imageObjectPosition: popup.imageObjectPosition,
  imageScale: popup.imageScale,
  imageUrl: popup.imageUrl,
});

export const fetchHomePopups = async (): Promise<HomePopupItem[]> => {
  const popups = await http.get<PopupApiResponse[]>('/api/v1/popups');
  return popups.map(mapPopup);
};
